/* TypeScript file generated from Button.res by genType. */
/* eslint-disable import/first */


const $$toRE77295138: { [key: string]: any } = {"Nothing": 0, "Normal": 1};

const $$toRE124709062: { [key: string]: any } = {"Regular": 0, "Small": 1, "Icon": 2};

const $$toRE256299128: { [key: string]: any } = {"Contained": 0, "Outlined": 1, "None": 2};

const $$toRE354646326: { [key: string]: any } = {"Red": 0, "Charcoal": 1, "White": 2, "BusinessPurple": 3, "BusinessCharcoal": 4, "Primary": 5, "Secondary": 6, "Tertiary": 7};

// @ts-ignore: Implicit any on import
import * as ButtonBS__Es6Import from './Button.bs';
const ButtonBS: any = ButtonBS__Es6Import;

import type {colour as Theme__Input_colour} from '../../../../src/theme/Theme__Input.gen';

import type {element as Jsx_element} from '../../../../src/shims/Jsx.shim';

import type {fill as Theme__Input_fill} from '../../../../src/theme/Theme__Input.gen';

import type {shadow as Theme__Input_shadow} from '../../../../src/theme/Theme__Input.gen';

import type {variant as Theme__Input_variant} from '../../../../src/theme/Theme__Input.gen';

// tslint:disable-next-line:interface-over-type-literal
export type props<children,fill,colour,variant,shadow,className> = {
  readonly children: children; 
  readonly fill?: fill; 
  readonly colour?: colour; 
  readonly variant?: variant; 
  readonly shadow?: shadow; 
  readonly className?: className
};

export const make: (_1:props<JSX.Element,Theme__Input_fill,Theme__Input_colour,Theme__Input_variant,Theme__Input_shadow,string>) => Jsx_element = function (Arg1: any) {
  const result = ButtonBS.make({children:Arg1.children, fill:(Arg1.fill == null ? Arg1.fill : $$toRE256299128[Arg1.fill]), colour:(Arg1.colour == null ? Arg1.colour : typeof(Arg1.colour) === 'object'
    ? {TAG: 0, _0:Arg1.colour[0], _1:Arg1.colour[1], _2:Arg1.colour[2]} as any
    : $$toRE354646326[Arg1.colour]), variant:(Arg1.variant == null ? Arg1.variant : $$toRE124709062[Arg1.variant]), shadow:(Arg1.shadow == null ? Arg1.shadow : $$toRE77295138[Arg1.shadow]), className:Arg1.className});
  return result
};
